import ReusableDataTable from "src/components/table/ReusableDataTable";
import { mapIotCallingCampaignToDataTable as mapData } from "./Helper";
import GetIotCallingCampaignColumn from "./ColumnDefinition/IotCallingCampaignColumn/GetIotCallingCampaignColumn";

const IotCallingCampaignTable = ({
  data,
  handleDelete,
  handleOpenPopup,
  status,
}) => {
  const columns = GetIotCallingCampaignColumn({
    handleDelete,
    handleOpenPopup,
    status,
  });

  return (
    <ReusableDataTable columns={columns} data={mapData(data)} maxHeight={500} />
  );
};

export default IotCallingCampaignTable;
